import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const Ring = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid #d1d5db;
  border-top-color: #2563eb;
  animation: ${spin} 0.7s linear infinite;
`;

export default function Spinner({ label }) {
  return (
    <Wrap>
      <Ring />
      {label && <span style={{ color: '#4b5563', fontWeight: 600, fontSize: 14 }}>{label}</span>}
    </Wrap>
  );
}
